import { loadComponent } from '../../utils/lazy';

export const ActivatePage = loadComponent(
  () => import(/* webpackChunkName: "signup" */ '../activate/activate-page'),
);

export const AuthenticatePage = loadComponent(
  () => import(/* webpackChunkName: "authenticate" */ '../authenticate/authenticate'),
);

export const AuthorizePage = loadComponent(
  () => import(/* webpackChunkName: "authorize" */ '../authorize/authorize'),
);

export const RegisterPage = loadComponent(
  () => import(/* webpackChunkName: "register" */ '../register/register'),
);

export const LaunchPage = loadComponent(
  () => import(/* webpackChunkName: "launch" */ '../launch/launch'),
);

export const SignupPage = loadComponent(
  () => import(/* webpackChunkName: "signup" */ '../signup/signup-page'),
);

export const WelcomePage = loadComponent(
  () => import(/* webpackChunkName: "welcome" */ '../launch/welcome/welcome-page'),
);

export const HomePage = loadComponent(
  () => import(/* webpackChunkName: "welcome" */ '../home/home-page'),
);

export const InstallPage = loadComponent(
  () => import(/* webpackChunkName: "install" */ '../install/install-page'),
);

export const PromotionalShowPage = loadComponent(
  () => import('../launch/promotional-show/promotional-show-page'),
);

export const VsCablePage = loadComponent(
  () => import(/* webpackChunkName: "welcome" */ '../launch/vs-cable/vs-cable-landing-page'),
);

export const GenrePage = loadComponent(
  () => import(/* webpackChunkName: "welcome" */ '../launch/genre/genre-page'),
);
